const mainApi = {
  shopList: '/api/scm/shop/list',
  getShopListByAccount: '/api/account/query/getShopListByAccount',
  getBindAccountList: '/api/account/query/getBindAccountList', // 旧版品牌列表
  // 改为新版品牌列表
  getAccountBrandList: '/api/account/query/getBrandAccountListWithNoBrand',
  // getAccountBrandList: '/api/account/query/getBindAccountList',
  accountDetail: '/api/account/query/detail',
  getBindContactPopUp: '/api/account/b/bindContactPopUp', // 获取账号绑定弹窗展示状态
  loginOut: '/api/user/v1/logout/pc/reset-token',
  getShopInfo: '/api/scm/shop/base/info',
  queryEntityLogoAndMainPic: '/api/operate/overview/queryEntityLogoAndMainPic',
  getShopSummary: '/api/scm/shop/base/summary',
  getUinfo: '/api/user/v1/info',
  shopReset: '/api/scm/shop/status/set-rest',
  shopOpen: '/api/scm/shop/status/set-open',
  menuAuthFilter: '/api/order/merchant/authFilter',
  // 商家成长任务菜单依赖的任务状态
  shopGrowthPlanInfo: '/api/operate/growth/taskAwardSample',
  menuAuthFilterAd: '/api/bff/ad/poi/v1/common/quality/query/authorize',
  getcategorylist: '/api/msgcenter/inbox/getcategorylist',
  afterSaleOrder: '/api/order/statisticsAfterSaleOrder',
  getNewOrders: '/api/order/getNewOrdersWithCount',
  getWebOrders: '/api/order/getWebOrders',
  confirmOrder: '/api/order/confirm',
  queryI18nInfo: '/api/scm/shop/queryI18nInfo',
  rbacAuthGrayConfig: '/api/account/b/auth/grayConfig',
  rbacAuthResource: '/api/account/b/auth/getResourceListByAcctId',
  shopBaseSummaryList: '/api/scm/gw/shop/base/summary/list',

  /**
   * 获取商家配置信息
   */
  getMerchantConfig: '/api/order/getMerchantConfig',

  /**
   * 根据token获取未读消息数
   */
  getMerchantMessageCount: '/api/cs/chat/message/count',

  /**
   * 是否有会话消息
   */
  getMerchantMessageDisplay: '/api/cs/suspended/window',

  /**
   * 查询健康度简短信息, 月度弹窗
   */
  postShopHealthyFirstLogin: '/api/operate/healthy/firstLogin',

  // 设置商家暂停接单
  setShopPauseStatus: '/api/order/setShopPauseStatus',
  // 设置商家置休期间是否继续出餐
  setKeepPreparing: '/api/order/setKeepPreparing',

  // 获取自入驻门店列表
  getSettledShopList: '/api/scm/partner/selfEntry/queryClueListByChainEmail',
  // 商家闭店原因
  getShopCloseReason: '/api/scm/shop/status/restTaskList',
  // IM入口展示判断
  getShowImMsgBox: '/api/im/canShowImMsgBox',
  // 获取门店和品牌信息
  getShopAndBrandInfo: '/api/account/query/getShopListByAccountV2',
  // 商品诊断报告存在性查询（是否存在有效报告及是否已读）
  diagnosisReportExists: '/api/merchant/growth/diagnosis/report/exists',
}

const pt = 'poi'
const version = 'v1'
const prodName = 'sspcpc'

export const adApi = {
  getAdGuideInfo: `/api/bff/ad/${pt}/${version}/${prodName}/operation/query`,
  updateAdGuideInfo: `/api/bff/ad/${pt}/${version}/${prodName}/operation/update`,
}

export const openApi = {
  getAuthMenuVisible: '/api/open/merchant/getAppManagementTabVisible',
}

export default mainApi
